import { render, staticRenderFns } from "./FornecedorCarousel.vue?vue&type=template&id=d78a4a58&scoped=true&"
import script from "./FornecedorCarousel.vue?vue&type=script&lang=js&"
export * from "./FornecedorCarousel.vue?vue&type=script&lang=js&"
import style0 from "./FornecedorCarousel.vue?vue&type=style&index=0&id=d78a4a58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78a4a58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCarousel,VCarouselItem,VCol,VRow})
